<template>
    <div class="box">
      <div>
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="mini">
          <el-form-item label="电话" prop="phone" >
            <el-autocomplete
              popper-class="my-autocomplete"
              :fetch-suggestions="queryOwner"
              placeholder="请输入电话"
              @select="handleSelectOwner"
              v-model="searchForm.phone"
              :trigger-on-focus="false"
            >
              <template slot-scope="{ item }">
                <div class="autoPhone"><i v-if="item.count >0" style="color: #d53131;">{{ item.phone }}</i><span v-else>{{ item.phone }}</span>&nbsp;{{ item.title }}</div>
                <span class="autoName">{{ item.name }}</span>
              </template>
            </el-autocomplete>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input v-model="searchForm.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-button size="mini" type="primary" @click="search" icon="el-icon-search" :loading="loading">搜索</el-button>
        </el-form>
      </div>
      <div>
        <el-table
          v-loading="loading"
          :data="driverList.records"
          :row-class-name="blackList"
          stripe
          :height="windowHeight"
          style="width: 100%;z-index: 1;font-size: 12px">
          <el-table-column
            prop="name"
            label="姓名"
            label-class-name="header">
          </el-table-column>
          <el-table-column
            prop="phone"
            label="电话"
            label-class-name="header">
          </el-table-column>
          <el-table-column
            prop="cars"
            label="车辆"
            label-class-name="header">
          </el-table-column>
          <el-table-column
            prop="address"
            label="地址"
            label-class-name="header">
          </el-table-column>
          <el-table-column
            prop="idcard"
            label="身份证号"
            label-class-name="header">
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            label-class-name="header">
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="driverList.current"
          :page-sizes="[15, 30, 50, 100]"
          :page-size="driverList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="driverList.total">
        </el-pagination>
      </div>
    </div>
</template>

<script>
import {getDriverForPhone, driverListByApp} from '../../../api/driver'
export default {
  data: function () {
    return {
      searchForm: {
        name: '',
        phone: '',
        appId: '',
        pageSize: 15,
        current: 1
      },
      driverList: [],
      windowHeight: '',
      loading: false
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.searchForm.appId = to.params.id
      vm.search()
    })
  },
  created () {
    this.windowHeight = document.documentElement.offsetHeight - 310
  },
  methods: {
    queryOwner (queryString, cb) {
      this.searchForm.driverId = ''
      getDriverForPhone(queryString).then((response) => {
        if (response.data.data.records.length > 0) {
          cb(response.data.data.records)
        } else {
          // eslint-disable-next-line
          cb([{
            phone: '',
            name: '',
            title: '没有匹配到'
          }])
        }
      })
    },
    handleSelectOwner (item) {
      this.searchForm.driverId = item.driverId
      this.searchForm.phone = item.phone
    },
    handleSizeChange (val) {
      this.searchForm.pageSize = val
      this.search()
    },
    handleCurrentChange (val) {
      this.searchForm.current = val
      this.search()
    },
    blackList ({row}) {
      if (row.count > 3) {
        return 'blackListPush'
      } else if (row.count > 0) {
        return 'blackList'
      }
      return ''
    },
    search () {
      this.loading = true
      let _this = this
      this.searchForm.current=1
      driverListByApp(this.searchForm).then((response) => {
        _this.driverList = response.data.data
        setTimeout(() => {
          _this.loading = false
        }, 1000)
      }).catch(() => {
        _this.loading = true
      })
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .blackList
    color #e86a6a
  .blackListPush
    color red
  .el-autocomplete-suggestion
    li
      line-height: normal !important
      padding: 7px !important
  .box
    padding 18px
    background #fff;
    border-radius 5px
    font-size 12px
    transition .3s
    box-shadow 0 0 8px 0 rgba(156, 156, 156, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5)
  .my-autocomplete
    .autoPhone
      text-overflow: ellipsis
      overflow: hidden
    .autoName
      font-size: 12px
      color: #b4b4b4
</style>
